import BaseLeadChartPage from '../BaseLeadChartPage/BaseLeadChartPage'

export default function LeadByLeadStatusChartPage (props) {
  return <BaseLeadChartPage pageName={props.pageName} groupByKey={"lead_status"} labelByKey={"lead_source"} showPercentedRatio/>
}
